import { Box } from "@mui/material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import TagIcon from "@mui/icons-material/Tag";
import { MATCH_BASIS_LABELS } from "../../constants";
import type { RegistryTagMatchBasis } from "../../types";

const icons = {
  NUMBER: TagIcon,
  ADDRESS: PlaceOutlinedIcon,
  BRANCH: QuestionMarkIcon,
} as const;

interface Props {
  basis: RegistryTagMatchBasis;
}

/**
 * 公的名簿の行が法人に紐付いた方法のマーク（# 法人番号・ピン 法人名と住所・? 同名の法人が全国で1社）。
 * 文言は出さず、読み上げとカーソルを当てたときにだけ方法の名前を出す
 * @param props.basis 紐付けの方法
 * @returns マーク
 */
export const MatchBasisMark: React.FC<Props> = ({ basis }) => {
  const Icon = icons[basis];
  const label = MATCH_BASIS_LABELS[basis];
  return (
    <Box
      component="span"
      role="img"
      aria-label={label}
      title={label}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "none",
        width: 18,
        height: 18,
        borderRadius: "50%",
        ...(basis === "NUMBER"
          ? { bgcolor: "primary.main", color: "primary.contrastText" }
          : {
              bgcolor: "background.paper",
              color: basis === "ADDRESS" ? "primary.main" : "text.secondary",
              border: 1.5,
              borderStyle: basis === "ADDRESS" ? "solid" : "dashed",
              borderColor: basis === "ADDRESS" ? "primary.main" : "grey.500",
            }),
      }}
    >
      <Icon sx={{ fontSize: 12 }} aria-hidden />
    </Box>
  );
};
